import React from 'react'
import arrayMutators from 'final-form-arrays'
import { Field, Form } from 'react-final-form'
import FormTextField from '../../../../../components/fields/FormTextField'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../../components/button/Button'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import Loader from '../../../../../components/loader/Loader'
import { PaymentFormModel } from '../../../../../types/contracts/contractsModel'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            formStyle: {
                marginBottom: 20,
                justifyContent: 'center',
                alignItems: 'center'
            },
            inputStyle: {
                marginTop: 20,
                marginBottom: 20,
                '& .MuiInput-formControl': {
                    '& .MuiInput-input': {
                        fontSize: 16,
                        fontWeight: 600,
                        color: theme.palette.primary.main,
                        opacity: 0.6
                    }
                }
            },
            spinnerStyle: {
                textAlign: 'center'
            }
        }
    )
)

interface AcceptingProps {
    onSubmit: (values: PaymentFormModel) => void,
    validate: (values: PaymentFormModel) => any,
    loading: boolean,
    initialValues: PaymentFormModel
}

type PaymentFormProps = AcceptingProps

const PaymentForm: React.FC<PaymentFormProps> = (
    {
        onSubmit,
        validate,
        loading,
        initialValues
    }
) => {
    const classes = useStyle()

    const buttonContainerClass: ClassValue = classNames(
        'col-xs-10 col-md-3'
    )

    return (
        <Form
            mutators={{
                ...arrayMutators
            }}
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            render={
                (
                    {
                        handleSubmit
                    }
                ) => (
                    <form
                        onSubmit={handleSubmit}
                        className={classNames('row', classes.formStyle)}
                    >
                        <div className={classNames('col-xs-12 col-md-9', classes.inputStyle)}>
                            <Field
                                name="amount"
                                component={FormTextField}
                                type="text"
                                adornment="€"
                                readOnly
                            />
                        </div>

                        <div className={buttonContainerClass}>
                            {loading ? (
                                <div className={classes.spinnerStyle}>
                                    <Loader />
                                </div>
                            ) : (<Button
                                    background="backgroundAccessibility"
                                    color="colorWhite"
                                    textStyle="text8"
                                    type="submit"
                                    size="bigButton"
                                >
                                    <FormattedMessage
                                        id="contracts.account.payment.btn"
                                        defaultMessage="Payer en ligne"
                                        description="Payment button"
                                    />
                                </Button>
                            )}
                        </div>
                    </form>
                )
            }
        />
    )
}

export default PaymentForm
